import React from 'react';
import DateRange from "../../../shared/DateRange";
import TextAsHTML from "../../../../components/_base/TextAsHTML";
import { EventPublicDetailsResponseType } from '../../../../lib/api';
import useSetKeyIdClass from '../../../../hooks/use-set-key-id-class';

import { useSpeakersList } from '../../../../hooks/api/protected/use-speaker-list';
import {
  SpeakerListResponseType,
} from '../../../../lib/api';

import { SpeakerOrganizationResponseType, SpeakerResponseType } from '../../../../lib/api';


interface EventPublicInfoInterface {
  data: EventPublicDetailsResponseType
}

const EventPublicInfo: React.FC<EventPublicInfoInterface> = (props) => {
  const { name, startTime, endTime, publicDescription, timeZone, logoUrl, logoTitle, eventTitleForPassport } = props.data;
  const key = useSetKeyIdClass();
  const className = key ? `editable-${key}` : 'editable-sign-in';
  const classNameContainer = `${className}--left-content`;
  const classNameTitle = `${className}--left-content-title`;
  const classNameDate = `${className}--left-content-date`;
  const classNameDescription = `${className}--left-content-description`;
  const eventTitle = eventTitleForPassport || name;

  const { data: speakerData } = useSpeakersList(String(props.data.eventId)) as { data: SpeakerListResponseType | void, isValidating: boolean };

  //console.log(props.data.eventId,speakerData,isValidating);

  return (
    <div className={`${classNameContainer} ml-6 lg:ml-0 w-full md:w-2/3 pr-12`} id='event-public-info'>
      <div>
        {logoUrl &&
          <img
            src={logoUrl}
            alt={logoTitle}
            title={logoTitle}
            style={{ objectFit: 'contain', height: '8rem', }}
          />}
      </div>
      <h2
        className={`${classNameTitle} header-font-size font-bold text-primary line-height-22px header-line word-break mt-5 pre-line`}
        title={eventTitle}
      >
        {eventTitle}
      </h2>
      <div className={`${classNameDate} text-primary font-bold mt-2 uppercase text-sm`}>
        <DateRange startTime={startTime} endTime={endTime} timeZone={timeZone} />
      </div>
      <div className={`${classNameDescription} mt-5 text-sm truncate-advanced-10`}><TextAsHTML formattedText={publicDescription} /></div>
      <>
        {
          speakerData && speakerData
            .map((organization: SpeakerOrganizationResponseType) => {
              return (
                <div id={`section${organization.organizationId}`} className={'organization'} key={organization.organizationId}>
                  <h2 className="text-xl">{organization.name}</h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {organization.speakers.map((speaker: SpeakerResponseType) => (
                      <div key={speaker.attendeeId} className="flex">
                        <div className="w-1/3 flex-shrink-0">
                          <img 
                            src={speaker.profileImageUrl} 
                            alt={`${speaker.firstName} ${speaker.lastName}`} 
                            className="w-full h-full object-contain"
                          />
                        </div>
                        <div className="w-2/3 px-4 pb-4">
                          <h3 className="text-base font-semibold text-black">
                            {speaker.lastName}
                          </h3>
                          <h3 className="text-base font-semibold text-black">
                            {speaker.firstName}
                          </h3>
                          <p className="text-xs text-black mb-1">{speaker.title}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })
        }
      </>
    </div>

  );
};

export default EventPublicInfo;
